import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { johnstonConfig } from "./data";

export default function JohnstonPage() {
  return <CityPageTemplate config={johnstonConfig} />;
}